var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterTopicList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7813 1.25H2.21875C1.54565 1.25 1 1.79565 1 2.46875V13.0313C1 13.7043 1.54565 14.25 2.21875 14.25H12.7813C13.4543 14.25 14 13.7043 14 13.0313V2.46875C14 1.79565 13.4543 1.25 12.7813 1.25Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4.13892H12.5H2.5H1V5.22225H2.5H12.5H14V4.13892ZM14 7.3889H12.5H2.5H1V8.47224H2.5H12.5H14V7.3889ZM12.5 10.6389H14V11.7222H12.5H2.5H1V10.6389H2.5H12.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterTopicList);
export default __webpack_public_path__ + "static/media/filter-topic-list.58892af12adbf9a4a90b5721b2fae920.svg";
export { ForwardRef as ReactComponent };